import React from "react";
import { useScrollReveal } from "hooks/useScrollReveal";

interface FadeInProps {
  children: React.ReactNode;
  direction?: "up" | "down";
  duration?: number;
  distance?: string;
}

export const FadeIn: React.FC<FadeInProps> = ({
  children,
  direction = "up",
  duration = 600,
  distance = "20px",
}) => {
  const transformValue =
    direction === "down"
      ? `translateY(-${distance})`
      : `translateY(${distance})`;
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <div
      ref={ref}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : transformValue,
        transition: `opacity ${duration}ms ease-out, transform ${duration}ms ease-out`,
      }}
    >
      {children}
    </div>
  );
};
